import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { mutate, useSWRConfig } from 'swr';

import { mixedLoginMethods } from '@/utils/constants.tsx';

import {
  basicManager,
  oauthManager,
  oauthProviderSpecificManager,
  supabase,
} from '../utils/backend-auth.tsx';
import { AuthContext } from './useAuth/AuthContext.tsx';
import { useStoredOrganizationId } from './useStoredOrganizationId/index.ts';

export function useLogout() {
  const navigate = useNavigate();
  const { setOrgId } = useStoredOrganizationId();
  const [, setSession] = useContext(AuthContext);
  const { cache } = useSWRConfig();
  return useCallback(async () => {
    await Promise.all([
      // sign out from supabase
      supabase?.auth?.signOut?.(),
      oauthManager?.removeUser(),
      oauthManager?.events._raiseUserSignedOut(),
      basicManager?.signOut(),
      oauthProviderSpecificManager?.signOut(),
      setSession(null),
      setOrgId(''),
      // clear fetch cache
      mutate(
        () => true, // all cache keys
        undefined, // update cache data to `undefined`
        { revalidate: false } // do not revalidate
      ).then(() => {
        for (const key of cache.keys()) {
          if (key !== 'user') {
            cache.delete(key);
          }
        }
      }),
    ]);
    setTimeout(() => {
      // skip navigation because signout action will navigate
      if (!mixedLoginMethods.customOidc) {
        navigate('/');
      }
    }, 0);
  }, [navigate]);
}
